import { Bot, Sparkles, Zap, Users, MessageCircle, MessageSquare, type LucideIcon } from '../../../icons';

export type WatermarkKind = 'ai' | 'group' | 'direct';

interface FloatSpec {
  Icon: LucideIcon;
  size: number;
}

/** 종류별 떠다니는 아이콘 구성 (4개) + 중앙 대형 워터마크 아이콘. */
const SPEC: Record<WatermarkKind, { big: LucideIcon; floats: FloatSpec[] }> = {
  ai: {
    big: Bot,
    floats: [
      { Icon: Sparkles, size: 26 },
      { Icon: Zap, size: 20 },
      { Icon: Sparkles, size: 16 },
      { Icon: Bot, size: 22 },
    ],
  },
  group: {
    big: Users,
    floats: [
      { Icon: Users, size: 24 },
      { Icon: MessageSquare, size: 20 },
      { Icon: Users, size: 16 },
      { Icon: MessageCircle, size: 22 },
    ],
  },
  direct: {
    big: MessageCircle,
    floats: [
      { Icon: MessageSquare, size: 24 },
      { Icon: MessageCircle, size: 18 },
      { Icon: MessageSquare, size: 15 },
      { Icon: MessageCircle, size: 22 },
    ],
  },
};

/**
 * ChatTypeWatermark (v2.11) — 대화창 배경 워터마크 애니메이션.
 * 방 종류(AI/그룹/1:1)별 어울리는 인라인 SVG 아이콘이 저불투명도로
 * 느리게 부유(drift)·맥동(pulse)한다. pointer-events 차단 + aria-hidden 장식 전용.
 * reduced-motion 은 CSS 가드에서 animation: none (정적 워터마크 유지).
 */
export function ChatTypeWatermark({ kind }: { kind: WatermarkKind }) {
  const spec = SPEC[kind];
  const Big = spec.big;
  return (
    <div className={`chat-wm chat-wm--${kind}`} aria-hidden="true">
      {kind === 'ai' && <span className="chat-wm-orb" />}
      <span className="chat-wm-big">
        <Big size={220} strokeWidth={1.2} />
      </span>
      {spec.floats.map((f, i) => (
        <span key={i} className={`chat-wm-f chat-wm-f--${i + 1}`}>
          <f.Icon size={f.size} />
        </span>
      ))}
    </div>
  );
}
